import { useGameStore } from '../store';
import { fmt } from '../utils/format';
import { liqPriceFor } from '../utils/liquidation';

export default function PositionBar() {
  const position = useGameStore((s) => s.position);
  const cash     = useGameStore((s) => s.cash);
  const prices   = useGameStore((s) => s.prices);

  if (!position) return null;

  const cur    = prices[position.symbol].at(-1)!;
  const rawPct = (cur - position.entryPrice) / position.entryPrice;
  let levPct   = rawPct * position.leverage;
  if (position.boosted) levPct = levPct > 0 ? levPct * 2 : levPct * 0.5;

  const pnlAmt  = Math.floor(position.amount * levPct);
  const isProfit = pnlAmt >= 0;
  const sg       = isProfit ? '+' : '';
  const col      = isProfit ? 'var(--up)' : 'var(--down)';

  const liqP = liqPriceFor(position, cash);

  const origin = cash + position.amount;
  const danger = origin > 0 && (cash + position.amount * (1 + levPct)) / origin < 0.3;

  return (
    <div id="position-bar" className={danger ? 'danger' : undefined}>
      <div className="pos-row">
        <span className="pos-label">보유 물량 손익</span>
        <span id="pnl-pct" style={{ color: col }}>
          {sg}{(levPct * 100).toFixed(2)}%
        </span>
      </div>
      <div className="pos-row">
        <span className="pos-label">사재기가</span>
        <span className="pos-value">
          {Math.round(position.entryPrice).toLocaleString('ko-KR')}냥
        </span>
      </div>
      <div className="pos-row">
        <span className="pos-label">강제청산가</span>
        <span className="pos-value" style={{ color: 'var(--up)' }}>
          {liqP !== null ? Math.round(liqP).toLocaleString('ko-KR') + '냥' : '도달 불가'}
        </span>
      </div>
      <div className="pos-row">
        <span className="pos-label">평가손익</span>
        <span className="pos-value" style={{ color: col }}>
          {sg}{fmt(pnlAmt)}냥
        </span>
      </div>
    </div>
  );
}
